/**
 * @ngdoc service
 * @name BB.uib.runtimeUibModal
 *
 * @description
 * Returns an instance of $uibModalProvider that allows to set modal default options (on runtime)
 */
function RuntimeUibModalProvider($uibModalProvider) {
    'ngInject';

    let uibModalProvider = $uibModalProvider;
    this.setProvider = provider => uibModalProvider = provider;
    this.$get = () => uibModalProvider;
}

export default RuntimeUibModalProvider;

angular
    .module('BB.uib')
    .provider('runtimeUibModal', RuntimeUibModalProvider);


// WEBPACK FOOTER //
// ../node_modules/bookingbug-angular/src/core/-uib/_services/runtime_uib_modal.provider.js